import {
  ApiClient,
  ApiClientContext,
  ApiClientOptions,
  RouteOptions,
  defaultAxiosConfig,
} from '@qualifio/api-client';
import { AxiosInstance } from 'axios';
import { Leaderboard } from './types';

export interface DeleteRankingsByProfileQueryParams {
  programId?: string;
}

export class LeaderboardApiClient extends ApiClient {
  static serviceName = 'leaderboard-api';

  constructor(http?: AxiosInstance, context?: ApiClientContext, options?: ApiClientOptions) {
    super('/api/leaderboard', http, context, options);
  }

  async getLeaderboard(
    programId: string,
    currencyId: string,
    profileId: string,
    options?: RouteOptions,
  ): Promise<Leaderboard> {
    const { data } = await this.http.get(
      `/programs/${programId}/leaderboards/${currencyId}/${profileId}`,
      defaultAxiosConfig(options),
    );
    return data;
  }

  async resetProgram(programId: string, options?: RouteOptions): Promise<void> {
    await this.http.delete(`/programs/${programId}/reset`, defaultAxiosConfig(options));
  }
}
